import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgPlusIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 48 48"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M22.8 22.8V9.6h2.4v13.2h13.2v2.4H25.2v13.2h-2.4V25.2H9.6v-2.4z"
    />
  </svg>
)
export default SvgPlusIcon
